export class CodaBoxConfig {
	Connected: boolean = false;
	StartDate: string = "";

	public constructor(data?: any) {
		if (!data) return;
		this.Connected = data.Connected || false;
		this.StartDate = data.StartDate || "";
	}

	public getJSON() {
		return {
			StartDate: this.StartDate,
		};
	}
}
